import PropTypes from "prop-types";
import React from "react";

import model from "js/models/positions";
import SimilarPositions from "js/views/app/summary/summary-similar";
import initJQuery from "lib/vendor/jquery";

export default class ApplicationSummarySimilar extends React.PureComponent {
    static propTypes = {
        positions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    };

    componentDidMount() {
        initJQuery();

        const { positions } = this.props;

        new SimilarPositions({
            el: this.container,
            collection: new model.Positions(positions),
        }).render();
    }

    render() {
        return <div className="app-summary__similar" ref={(c) => (this.container = c)} />;
    }
}
